let _initProto, _initClass, _init_controls, _init_extra_controls, _init_buttonLabel, _init_extra_buttonLabel, _init_placement, _init_extra_placement, _init_variant, _init_extra_variant, _init_size, _init_extra_size, _init_buttonTarget, _init_extra_buttonTarget, _init_sidebarState, _init_extra_sidebarState;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, onEvent, onUpdated, prop, query, state } from "@ecopages/radiant";
let _RuiSidebarTrigger;
class RuiSidebarTrigger extends RadiantElement {
  static {
    ({
      e: [_init_controls, _init_extra_controls, _init_buttonLabel, _init_extra_buttonLabel, _init_placement, _init_extra_placement, _init_variant, _init_extra_variant, _init_size, _init_extra_size, _init_buttonTarget, _init_extra_buttonTarget, _init_sidebarState, _init_extra_sidebarState, _initProto],
      c: [_RuiSidebarTrigger, _initClass]
    } = _applyDecs(this, [customElement("rui-sidebar-trigger")], [[prop({
      type: String,
      defaultValue: ""
    }), 0, "controls"], [prop({
      type: String,
      attribute: "button-label",
      defaultValue: "Toggle sidebar"
    }), 0, "buttonLabel"], [prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "placement"], [prop({
      type: String,
      defaultValue: "ghost"
    }), 0, "variant"], [prop({
      type: String,
      defaultValue: "md"
    }), 0, "size"], [query({
      ref: "button"
    }), 0, "buttonTarget"], [state, 0, "sidebarState"], [onUpdated(["controls", "buttonLabel", "placement"]), 2, "onBindingUpdated"], [onUpdated(["variant", "size"]), 2, "onPresentationUpdated"], [onEvent({
      selector: '[data-ref="button"]',
      type: "click"
    }), 2, "onButtonClick"]], 0, void 0, RadiantElement));
  }
  controls = (_initProto(this), _init_controls(this));
  buttonLabel = (_init_extra_controls(this), _init_buttonLabel(this));
  placement = (_init_extra_buttonLabel(this), _init_placement(this));
  variant = (_init_extra_placement(this), _init_variant(this));
  size = (_init_extra_variant(this), _init_size(this));
  buttonTarget = (_init_extra_size(this), _init_buttonTarget(this));
  sidebarState = (_init_extra_buttonTarget(this), _init_sidebarState(this, "expanded"));
  sidebarListener = (_init_extra_sidebarState(this), null);
  attachedSidebar = null;
  initialSyncFrame = null;
  /**
   * @remarks JSX `.prop` bindings flush after connect when the trigger is nested in sidebar chrome.
   *
   * The triple sync is deliberate, not redundant:
   * - the synchronous call covers triggers rendered outside any sidebar;
   * - the nested microtasks hop past the *sidebar's* own `onConnected` sync
   *   (connection order does not guarantee the sidebar ran first), so state
   *   read here is post-sync;
   * - the animation frame is a final pass after layout settles (mobile media
   *   query flips land there).
   */
  connectedCallback() {
    super.connectedCallback();
    this.syncWithSidebar();
    queueMicrotask(() => queueMicrotask(() => this.syncWithSidebar()));
    this.initialSyncFrame = requestAnimationFrame(() => {
      this.initialSyncFrame = null;
      this.syncWithSidebar();
    });
  }
  disconnectedCallback() {
    if (this.initialSyncFrame != null) {
      cancelAnimationFrame(this.initialSyncFrame);
      this.initialSyncFrame = null;
    }
    this.detachFromSidebar();
    super.disconnectedCallback();
  }
  onBindingUpdated() {
    this.detachFromSidebar();
    this.syncWithSidebar();
    this.applyState(this.attachedSidebar ? this.readState(this.attachedSidebar) : "expanded");
  }
  onPresentationUpdated() {
    this.syncButtonPresentation();
  }
  resolveSidebar() {
    const id = this.controls?.trim();
    if (id) {
      const byId = document.getElementById(id);
      if (byId) {
        return byId;
      }
    }
    const host = this.closest("rui-sidebar");
    if (host?.id) {
      return host;
    }
    return null;
  }
  syncWithSidebar() {
    const sidebar = this.resolveSidebar();
    if (sidebar === this.attachedSidebar) {
      if (sidebar) this.applyState(this.readState(sidebar));
      return;
    }
    this.detachFromSidebar();
    if (!sidebar) return;
    this.attachedSidebar = sidebar;
    this.sidebarListener = event => {
      const detail = event.detail;
      this.applyState(detail.state);
    };
    sidebar.addEventListener("rui-sidebar-toggle", this.sidebarListener);
    this.applyState(this.readState(sidebar));
  }
  detachFromSidebar() {
    if (this.attachedSidebar && this.sidebarListener) {
      this.attachedSidebar.removeEventListener("rui-sidebar-toggle", this.sidebarListener);
    }
    this.attachedSidebar = null;
    this.sidebarListener = null;
  }
  readState(sidebar) {
    return sidebar.getAttribute("data-state") ?? "expanded";
  }
  resolvedPlacement() {
    if (this.classList.contains("rui-sidebar-trigger-placement--header")) return "header";
    if (this.classList.contains("rui-sidebar-trigger-placement--inset")) return "inset";
    const placement = this.getAttribute("data-placement");
    if (placement === "header" || placement === "inset") return placement;
    return this.placement;
  }
  resolvedButtonLabel(state2 = this.sidebarState) {
    if (this.resolvedPlacement() === "inset") {
      return state2 === "expanded" ? "Close navigation" : "Open navigation";
    }
    const fromData = this.getAttribute("data-button-label")?.trim();
    if (fromData) return fromData;
    const fromAttribute = this.getAttribute("button-label")?.trim();
    if (fromAttribute) return fromAttribute;
    return this.buttonLabel || "Toggle sidebar";
  }
  applyState(state2) {
    this.sidebarState = state2;
    const button = this.buttonTarget;
    if (!button) return;
    const sidebar = this.resolveSidebar();
    const buttonLabel = this.resolvedButtonLabel(state2);
    button.setAttribute("aria-expanded", String(state2 === "expanded"));
    button.setAttribute("data-sidebar-state", state2);
    button.setAttribute("aria-label", buttonLabel);
    if (sidebar?.id) {
      button.setAttribute("aria-controls", sidebar.id);
    } else if (this.controls) {
      button.setAttribute("aria-controls", this.controls);
    }
    this.syncButtonPresentation();
  }
  syncButtonPresentation() {
    const button = this.buttonTarget;
    if (!button) return;
    button.className = `rui-button rui-button--${this.variant} rui-button--${this.size} rui-sidebar__trigger ${this.placementClass()}`.trim();
  }
  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const sidebar = this.resolveSidebar();
    if (sidebar && typeof sidebar.toggle === "function") {
      sidebar.toggle();
    }
  }
  placementClass() {
    if (this.resolvedPlacement() === "header") return "rui-sidebar__trigger--header";
    if (this.resolvedPlacement() === "inset") return "rui-sidebar__trigger--inset";
    return "";
  }
  static {
    _initClass();
  }
}
export { _RuiSidebarTrigger as RuiSidebarTrigger };